import React from "react";

// mui components
import { Box, Stack } from "@mui/material";

// custom components
import SecondaryButton from "../buttons/secondary-button";
import Body2 from "../typography/body-02";
import Body3 from "../typography/body-03";

// mui icons
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";

// helper utils
import { DIRECT_PATH_CONSTANTS } from "../../utils/direct-path.constants";

// custom styles
import styles from "./index.module.scss";

const DirectPathPrompt = ({ onSelect, error }) => {
	// const handleLearnMore = () => {
	// 	if (!DIRECT_PATH_CONSTANTS.LEARN_MORE_URL) return;
	// 	window.open(
	// 		DIRECT_PATH_CONSTANTS.LEARN_MORE_URL,
	// 		"_blank",
	// 		"noopener,noreferrer"
	// 	);
	// };

	return (
		<Stack direction="column" className={styles.promptContainer}>
			<Stack direction="row" className={styles.headerContainer}>
				<RouteOutlinedIcon className={styles.headerIcon} />
				<Body2
					text={DIRECT_PATH_CONSTANTS.PROMPT_HEADER}
					fontType="semibold"
					extraClass={styles.headerText}
				/>
				<Box className={styles.eligibleTag}>
					<Body3 text={DIRECT_PATH_CONSTANTS.ELIGIBLE_TAG} />
				</Box>
			</Stack>

			<Body3
				text={DIRECT_PATH_CONSTANTS.PROMPT_HELPER}
				extraClass={styles.helperText}
			/>

			<Body3
				text={DIRECT_PATH_CONSTANTS.FEE_TEXT}
				fontType="semibold"
				extraClass={styles.feeText}
			/>

			<Stack direction="row" className={styles.actionContainer}>
				<SecondaryButton
					text={DIRECT_PATH_CONSTANTS.YES_BUTTON}
					startIcon={
						<RouteOutlinedIcon className={styles.directPathBtnIcon} />
					}
					extraClass={styles.selectionBtn}
					onClick={() => onSelect(true)}
				/>
				<SecondaryButton
					text={DIRECT_PATH_CONSTANTS.NO_BUTTON}
					startIcon={
						<AccountBalanceOutlinedIcon className={styles.standardBtnIcon} />
					}
					extraClass={styles.selectionBtn}
					onClick={() => onSelect(false)}
				/>
				{/*
				<Body3
					text={DIRECT_PATH_CONSTANTS.LEARN_MORE}
					isLink
					handleClick={handleLearnMore}
				/>
				*/}
			</Stack>

			{error && (
				<Body3
					text={DIRECT_PATH_CONSTANTS.SELECTION_REQUIRED}
					error
					extraClass={styles.errorText}
				/>
			)}
		</Stack>
	);
};

export default DirectPathPrompt;
